<template>
  <section :class="['w-full last:mb-0', kompakt ? 'mb-4' : 'mb-6']">
    <!-- Bolum basligi: ikon + baslik + ayrac -->
    <div :class="['flex items-center gap-2 border-b border-gray-200 dark:border-gray-700', kompakt ? 'pb-1.5 mb-3' : 'pb-2 mb-4']">
      <i
        v-if="ikon"
        :class="['pi', ikon, 'text-base text-primary-500 dark:text-primary-400']"
        aria-hidden="true"
      ></i>
      <h3 class="text-sm font-semibold text-gray-800 dark:text-gray-100 m-0">{{ baslik }}</h3>
      <span v-if="aciklama" class="text-xs text-gray-500 dark:text-gray-400 ml-1">{{ aciklama }}</span>
      <div class="ml-auto flex items-center gap-2">
        <slot name="sag"></slot>
      </div>
    </div>

    <!-- Alanlar: varsayilan olarak responsive grid, sutun sayisi disaridan ayarlanabilir -->
    <div :class="izgaraSinifi">
      <slot></slot>
    </div>
  </section>
</template>

<script>
// Form bolumu — bir formu anlamli parcalara ayirir (Kimlik / Iletisim / Diger gibi).
// FormAlan ile birlikte kullanilir; projedeki tum formlarin ortak iskeleti budur.
// Kayit yeri: main.js (global). Import gerekmez.
export default {
  name: "FormBolum",
  // S360-A: saglayici konsolu (Sirket 360 → Ayarlar) provide("konsolModu", true) → sik aralik.
  inject: { kompakt: { from: "konsolModu", default: false } },
  props: {
    baslik: { type: String, required: true },
    // PrimeIcons sinifi, "pi-" onekiyle. Orn: "pi-user"
    ikon: { type: String, default: "" },
    aciklama: { type: String, default: "" },
    // Genis ekranda kac sutun olsun (1-3 arasi)
    sutun: { type: [Number, String], default: 2 },
  },
  computed: {
    izgaraSinifi() {
      const s = Number(this.sutun) || 2;
      const ara = this.kompakt ? "gap-x-4 gap-y-3" : "gap-4";
      if (s === 1) return "grid grid-cols-1 " + ara;
      if (s === 3) return "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 " + ara;
      return "grid grid-cols-1 md:grid-cols-2 " + ara;
    },
  },
};
</script>
